import { CSSProperties, ReactNode, Ref, createElement } from 'react';
import { cn } from 'shared/utils/cn';

export type HeadingVariant = 'display' | 'page' | 'section' | 'card' | 'sub';
export type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface HeadingProps {
  variant: HeadingVariant;
  as?: HeadingLevel;
  id?: string;
  className?: string;
  style?: CSSProperties;
  innerRef?: Ref<HTMLHeadingElement>;
  children: ReactNode;
}

const variantClasses: Record<HeadingVariant, string> = {
  display: 'font-serif text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-tight',
  page: 'font-serif text-4xl md:text-6xl tracking-tight leading-tight',
  section: 'font-serif text-4xl md:text-5xl leading-tight',
  card: 'font-serif text-2xl leading-snug',
  sub: 'font-serif text-xl leading-snug',
};

const defaultLevelFor: Record<HeadingVariant, HeadingLevel> = {
  display: 'h1',
  page: 'h1',
  section: 'h2',
  card: 'h3',
  sub: 'h4',
};

export const Heading = ({
  variant,
  as,
  id,
  className,
  style,
  innerRef,
  children,
}: HeadingProps) => {
  const Tag = as ?? defaultLevelFor[variant];
  return createElement(
    Tag,
    {
      id,
      style,
      ref: innerRef,
      className: cn(variantClasses[variant], className),
    },
    children,
  );
};
